import { createSelector } from 'reselect';
import { getProp } from '../../utilities';

const stepperDomainSelector = state => state.stepper;
const paramsDomainSelector = state => state.connectionParams;
const otherContentDomainSelector = state => state.otherContent;
const messagesDomain = state => state.messages;
const paygateMessagesDomain = state => state.paygateMessages;
const alertDomain = state => state.alert;

export const currentStepSelector = createSelector(
  stepperDomainSelector,
  substate => substate.currentStep,
);

export const passangerNumberSelector = createSelector(
  paramsDomainSelector,
  substate => substate.count,
);

export const ticketTypeSelector = createSelector(
  paramsDomainSelector,
  substate => substate.ticketType,
);

const otherContentDomain = id =>
  createSelector(otherContentDomainSelector, substate =>
    getProp(substate, [id], {}),
  );

export const otherContentNameSelector = id =>
  createSelector(otherContentDomain(id), substate =>
    getProp(substate, ['data', 'name'], null),
  );

export const otherContentContentSelector = id =>
  createSelector(otherContentDomain(id), substate =>
    getProp(substate, ['data', 'body'], null),
  );

export const otherContentIsFetchingSelector = id =>
  createSelector(otherContentDomain(id), substate =>
    getProp(substate, ['isFetching'], false),
  );

export const alertSelector = createSelector(alertDomain, substate => substate);

export const messagesSelector = createSelector(
  messagesDomain,
  substate => substate,
);

export const paygateMessagesSelector = createSelector(
  paygateMessagesDomain,
  substate => substate,
);



// WEBPACK FOOTER //
// ./src/containers/App/selectors.js